import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/terms.css';
import Bubble from '../components/Bubble';

const Terms = () => {
  const { t } = useTranslation();
  
  return (
    <div className="terms-page">
      <h1 className="terms-title">{t('terms.page.title')}</h1>
      
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        gap: '25px', 
        padding: '15px',
        marginBottom: '40px'
      }}>
        {/* Primera fila: Burbujas 1 y 2 */}
        <div style={{ 
          display: 'flex', 
          flexDirection: 'row',
          justifyContent: 'space-between',
          gap: '20px', 
          flexWrap: 'wrap'
        }}>
          {/* Burbuja 1: Advertencias de Riesgo */}
          <Bubble 
            className="bubble-1"
            title="Advertencias de Riesgo:"
            content=" La inversión en eDOP Token implica riesgos importantes, incluyendo
            alta volatilidad y la posible pérdida total o parcial del capital.
            El valor del token depende del mercado, no hay garantía de rentabilidad
            y los activos digitales no cuentan con seguros de depósito. Considere
            cuidadosamente su tolerancia al riesgo antes de invertir."
            translationKey="bubbles.terms.risk"
            color="blue"
            position="center"
            size="medium"
          />

          {/* Burbuja 2: Limitación de Responsabilidad */}
          <Bubble 
            className="bubble-2"
            title="Limitación de Responsabilidad"
            content="El rendimiento del eDOP Token está sujeto a riesgos
            de mercado fuera del control del emisor (Servicios de Desarrollo
            de Algoritmos y Consultoría de Tecnología Blockchain, SRL). No nos
            responsabilizamos por pérdidas derivadas de la volatilidad, fluctuaciones
            de liquidez o riesgos inherentes a la inversión en activos digitales."
            translationKey="bubbles.terms.liability"
            color="green"
            position="center"
            size="medium"
          />
        </div>
        
        {/* Espacio adicional entre filas de burbujas */}
        <div style={{ marginTop: '60px' }}></div>

        {/* Segunda fila: Burbujas 3 y 4 */}
        <div style={{ 
          display: 'flex', 
          flexDirection: 'row',
          justifyContent: 'space-between',
          gap: '20px', 
          flexWrap: 'wrap'
        }}>
          {/* Burbuja 3: Emisor y Cumplimiento Legal */}
          <Bubble 
            className="bubble-3"
            title="Emisor y Cumplimiento Legal"
            content="eDOP Token es emitido por Servicios de Desarrollo de Algoritmos
            y Consultoría de Tecnología Blockchain, SRL, entidad legalmente constituida.
            Buscamos operar en cumplimiento con las regulaciones aplicables y
            contamos con asesoría legal en materia de activos digitales y derecho
            financiero."
            translationKey="bubbles.terms.issuer"
            color="orange"
            position="center"
            size="medium"
          />

          {/* Burbuja 4: Contacto */}
          <Bubble 
            className="bubble-4"
            title="Contacto"
            content={
              <p>Para consultas relacionadas con estos términos, el proyecto
            eDOP Token o para más información, puede dirigirse a nuestro{' '}
            <a href="mailto:info@edoptoken.com" target="_blank" rel="noopener noreferrer">
              Correo Electrónico
            </a>: o consultar los recursos adicionales en nuestro {' '}
            <a href="https://www.edoptoken.com" target="_blank" rel="noopener noreferrer">
              Sitio Web
            </a>.
            </p>}
            translationKey="bubbles.terms.contact"
            color="purple"
            position="center"
            size="medium"
          />
        </div>
        
        {/* Espacio adicional entre filas de burbujas */}
        <div style={{ marginTop: '60px' }}></div>

        {/* Tercera fila: Burbuja 5 y 6 */}
        <div style={{ 
          display: 'flex', 
          flexDirection: 'row',
          justifyContent: 'space-between',
          gap: '20px', 
          flexWrap: 'wrap'
        }}>
       
        </div>
      </div>
    </div>
  );
};

export default Terms;
